<template>
    <h1>Ultra <br/> <span>Simulador</span></h1>
</template>

<script>
export default {
    name: 'Title'
}
</script>

<style lang="scss" scoped>
h1 {
    text-transform: uppercase;
    text-align: center;
    font-weight: bolder;
    font-style: italic;
    font-size: 115px;
    line-height: 80px;
    letter-spacing: 0;

    span {
        font-weight: 400;
        font-size: 90px;
        line-height: 109px;
    }
}

@media only screen and (max-width: 600px) {
  h1 {
    font-size: 80px;
    line-height: 11px;

    span {
        font-size: 40px;
    }
  }
}

</style>
